import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { ListElement } from '@website-builder/widgets/list/list-element';
import { ListTextStyle } from '@website-builder/widgets/list/model/list-text-style';
import { ListStyle } from '@website-builder/widgets/list/model/list-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class ListWidget extends BaseMultipleWidget<ListElement, ListStyle> {
  readonly type = BuilderElementType.List;
  style = new ListStyle();
  textStyle = new ListTextStyle();

  elements = [new ListElement(), new ListElement(), new ListElement(), new ListElement(), new ListElement()];

  static normalizeInPlace(widget: ListWidget): ListWidget {
    const pureWidget = new ListWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.elements = (widget.elements ?? pureWidget.elements).map(element => ListElement.normalizeInPlace(element));

    widget.style = ListStyle.normalize(widget.style);
    widget.textStyle = ListTextStyle.normalize(widget.textStyle);

    return widget;
  }
}
